import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import CompanyContext from 'context/CompanyContext'
import { Select } from 'components/inputs'

graphql`
  fragment CompanySelect_company on Company @relay(mask: false) {
    id
    name
  }
`

export default function CompanySelect(props) {
  const { loaded, companies } = React.useContext(CompanyContext)

  return (
    <Select
      {...props}
      loading={!loaded || props.loading}
      options={companies.map(company => ({
        value: company.id,
        text: company.name,
      }))}
    />
  )
}

CompanySelect.defaultProps = {
  label: 'Empresa',
  placeholder: 'Empresa',
  clearable: true,
}
